import { getApiConfigNext } from '@y-sports/api-client';

export interface TournamentScheduleSummaryTeam {
  id: string;
  name: string;
  gender?: string | null;
  homeColor?: string | null;
  awayColor?: string | null;
  goalkeeperColor?: string | null;
}

export interface TournamentScheduleSummaryCategory {
  id: string;
  name: string;
  gender?: string | null;
}

export interface TournamentScheduleSummaryCourt {
  id: string;
  name: string;
  venueId?: string | null;
  venueName?: string | null;
}

export interface TournamentScheduleSummaryMatch {
  id: string;
  tournamentId: string;
  teamA?: TournamentScheduleSummaryTeam | null;
  teamB?: TournamentScheduleSummaryTeam | null;
  category?: TournamentScheduleSummaryCategory | null;
  matchTime?: string | null;
  teamAScore?: number | null;
  teamBScore?: number | null;
  status?: string | null;
  winnerTeamId?: string | null;
  court?: TournamentScheduleSummaryCourt | null;
  groupName?: string | null;
  stageName?: string | null;
  label?: string | null;
  roundNumber?: number | null;
}

export interface TournamentScheduleSummaryResponse {
  matches: TournamentScheduleSummaryMatch[];
  dates: string[];
  courts: TournamentScheduleSummaryCourt[];
  categories: TournamentScheduleSummaryCategory[];
}

async function fetchNextJson<T>(path: string, parse: (json: unknown) => T): Promise<T> {
  const apiConfig = await getApiConfigNext();
  const response = await fetch(`${apiConfig.basePath}${path}`, {
    method: 'GET',
    headers: apiConfig.headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return parse(await response.json());
}

export const TournamentScheduleDataService = {
  getTournamentScheduleSummary: async (tournamentId: string): Promise<TournamentScheduleSummaryResponse> => fetchNextJson(
    `/tournaments/${tournamentId}/schedule-summary`,
    (json) => json as TournamentScheduleSummaryResponse,
  ),
};